export default __webpack_public_path__ + "assets/8037fb.svg";